export default "__VITE_ASSET__ec50dabd__"